interface DiamondImageProps {
	width?: string | number;
	alt?: string;
	classes?: string;
	src?: string;
}
/**
 * A React functional component that renders an image of a coin.
 *
 * @param {string} width - The width of the coin image (default: '25px').
 * @param {string} classes - Additional CSS classes to apply to the coin image.
 * @return {JSX.Element} The rendered coin image.
 */
export const DiamondImage: React.FC<DiamondImageProps> = ({
	width = '25px',
	alt = process.env.VITE_MINI_DIAMOND_IMAGE,
	classes,
	src,
}: DiamondImageProps) => {
	/*********************
	// #region Template
	**********************/
	return (
		<img
			src={src || process.env.VITE_MINI_DIAMOND_IMAGE}
			className={`drop-shadow-lg ${classes}`}
			width={width}
			alt={alt}
		/>
	);
};
